<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
           Enroll in PSP
         </h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a
             [routerLink]="['/driver/1']"
             (click)="scrollToTop()"
             name="Driver-record-request"
             id="Driver-record-request"
             [attr.title]="'Start_8-2' | translator:'base'"
             class="ms-1" 
           >
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar  [step]="2" [totalSteps]="19"></app-complete-bar>
               <h2 [innerHTML]="'GSMAH_Download Get Started' | translator:'base'">Let's Get Started</h2>
               <p class="step-text" [innerHTML]="'GSMAH_You should download' | translator:'base'">
                 You should download the enrollment agreement to thoroughly review all of your company's obligations with PSP.
                 Many choose to have their legal representation review the agreement before submission.
               </p>
               <hr />
               <p class="text-lg">
                 <label class="form-label w-100">
                   <span [innerHTML]="'GSMAH_Review agreement' | translator:'base'">Review enrollment agreement</span>
                 </label>
                 <button
                   (click)="openDocument('PSPMotorCarrierEnrollment')"
                   class="btn btn-primary"
                   [title]="'GSMAH_EnrollmentAgreement' | translator:'base'"
                   name="Enrollment-Agreement"
                   id="Enrollment-Agreement"
                 >
                   <span [innerHTML]="'GSMAH_EnrollmentAgreement' | translator:'base'">Enrollment Agreement</span> (PDF)
                 </button>
               </p>
               <p [innerHTML]="'GSMAH_agreement_will' | translator:'base'">
                 The agreement will open in a new tab. After you are finished reviewing the document, return here to finish
                 the enrollment process.
               </p>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group">
                   <button
                     [routerLink]="'/signup/5'"
                     class="btn btn-primary btn-strong"
                     (click)="scrollToTop()"
                     [title]="'MAHInfo' | translator:'base'"
                     name="companyNext2"
                     id="companyNext2"
                   >
                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'MAHInfo' | translator:'base'">Monthly Account Holder Info</span>
                   </button>
                 </div>
                 <div class="btn-group" role="group">
                   <button
                     [routerLink]="'/signup/1'"
                     class="btn btn-outline-primary"
                     (click)="scrollToTop()"
                     [title]="'Back' | translator:'base'"
                     name="companyBack2"
                     id="companyBack2"
                   >
                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                     <span class="sr-only"> to Welcome</span>
                   </button>
                   <button
                     [routerLink]="'/'"
                     class="btn btn-light"
                     (click)="scrollToTop()"
                     name="companyCancel2"
                     id="companyCancel2"
                     [innerHTML]="'Cancel' | translator:'base'"
                     [title]="'Cancel' | translator:'base'"
                   >
                     Cancel
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard  [wizardObj]="wizardObj" [activeStep]="1" [pageType]="enrollment.newCustomer!.customerType || '-'" class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard >
       </div>
     </div>
   </div>
   

